
import { Vue, Component, Prop } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import FooterBasic from '~/components/common/modals/basic/FooterBasic.vue'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  name: 'RemoveRequirement',
  components: {
    FooterBasic,
    DashboardButton,
    Icon,
    CloseCrossCtrl
  }
})
export default class RemoveRequirement extends Vue {
  @Prop({ required: true }) name: string
  @Prop({ default: () => {} }) remove

  close() {
    this.$emit('close')
  }

  get reqType(): string {
    return this.name ? this.name.toLowerCase() : ''
  }
}
